"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");
/**
 * Comunica datasource utilities
 */


var DataSourceUtils =
/*#__PURE__*/
function () {
  function DataSourceUtils() {
    _classCallCheck(this, DataSourceUtils);
  }

  _createClass(DataSourceUtils, null, [{
    key: "getSingleSource",

    /**
     * Get the single source if the context contains just a single source.
     * @param {ActionContext} context A context, can be null.
     * @return {Promise<IDataSource>} A promise resolving to the single datasource or null.
     */
    value: function () {
      var _getSingleSource = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(context) {
        var datasources, datasourcesArray;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(context && context.has(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCE))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", context.get(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCE));

              case 4:
                if (!(context && context.has(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES))) {
                  _context.next = 12;
                  break;
                }

                // If multiple sources are set
                datasources = context.get(bus_rdf_resolve_quad_pattern_1.KEY_CONTEXT_SOURCES);

                if (!datasources.isEnded()) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return require('arrayify-stream')(datasources.iterator());

              case 9:
                datasourcesArray = _context.sent;

                if (!(datasourcesArray.length === 1)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", datasourcesArray[0]);

              case 12:
                return _context.abrupt("return", null);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getSingleSource(_x) {
        return _getSingleSource.apply(this, arguments);
      }

      return getSingleSource;
    }()
    /**
     * Get the type of a single source
     * @param {ActionContext} context A context, can be null.
     * @return {Promise<string>} A promise resolving to the type of the source, can be null if source is null.
     */

  }, {
    key: "getSingleSourceType",
    value: function () {
      var _getSingleSourceType = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(context) {
        var source;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getSingleSource(context);

              case 2:
                source = _context2.sent;
                return _context2.abrupt("return", source ? bus_rdf_resolve_quad_pattern_1.getDataSourceType(source) : null);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getSingleSourceType(_x2) {
        return _getSingleSourceType.apply(this, arguments);
      }

      return getSingleSourceType;
    }()
    /**
     * Check if the given context has a single source of the given type.
     * @param {ActionContext} context An optional context.
     * @param {string} requiredType The required source type name.
     * @return {boolean} If the given context has a single source of the given type.
     */

  }, {
    key: "singleSourceHasType",
    value: function () {
      var _singleSourceHasType = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(context, requiredType) {
        var actualType, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getSingleSourceType(context);

              case 2:
                actualType = _context3.sent;
                result = actualType ? actualType === requiredType : false;
                return _context3.abrupt("return", result);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function singleSourceHasType(_x3, _x4) {
        return _singleSourceHasType.apply(this, arguments);
      }

      return singleSourceHasType;
    }()
  }]);

  return DataSourceUtils;
}();

exports.DataSourceUtils = DataSourceUtils;